import React, { memo } from 'react'

function EditTab() {
  return (
    <div className="image-assistant-panel__placeholder">
      <p className="image-assistant-panel__placeholder-text cgt-body-base">
        Image editing is coming soon.
      </p>
    </div>
  )
}

export default memo(EditTab)
